import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography, List } from '@material-ui/core'
import ThemeEditorColorList from './ThemeEditorColorList'

const ThemeEditorCard = props => {
  const { palette, onChange, label, name, fields } = props

  const handleChange = (xname, value) => {
    onChange(name, {
      ...palette,
      [xname]: value,
    })
  }

  return (
    <Box p={4}>
      <Box ml={4}>
        <Typography color="textSecondary">{label}</Typography>
      </Box>
      <List>
        {fields.map(item => (
          <ThemeEditorColorList
            key={item.name}
            label={item.label}
            name={item.name}
            onChange={handleChange}
            value={palette[item.name]}
          ></ThemeEditorColorList>
        ))}
      </List>
    </Box>
  )
}

ThemeEditorCard.propTypes = {
  palette: PropTypes.object,
  onChange: PropTypes.func,
  label: PropTypes.string,
  name: PropTypes.string,
  fields: PropTypes.array,
}

export default ThemeEditorCard
